import * as React from 'react';
import { OverlayTrigger, Tooltip, Card } from 'react-bootstrap';
import '../components/bloodworkz/bloodwork-ref-range-analysis.css';
import { Bloodwork, Section, PanelMarker } from '../models';
import { ReferenceRangeAnalysis } from '../components/bloodworkz/bloodwork-ref-range-analysis';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  title: string;
  section: Section;
  bloodwork: Bloodwork;
  previousBloodwork?: Bloodwork;
  panelMarkers: PanelMarker[];
  infoLink: string;
  // PDF export rendering — drops the interactive per-marker "learn more" icons
  // (they never appear in the exported PDF) so the marker names right-justify
  // with their values.
  forPdf?: boolean;
};

export class ReferenceRangeAnalysisContainer extends React.Component<Props, {}> {
  openWindow() {
    const { infoLink } = this.props;
    if (infoLink) {
      window.open(infoLink);
    }
  }

  render() {
    console.log('rendering ReferenceRangeAnalysisContainer ****************************************');

    const { title, section, bloodwork, previousBloodwork, panelMarkers, infoLink, forPdf } = this.props;
    if (!panelMarkers || panelMarkers.length === 0) {
      return null;
    }

    const refRangesInfoTooltip = (
      <Tooltip 
        id="modal-tooltip"
      >Click this icon to learn more about how these reference ranges were determined.
      </Tooltip>
    );

    return (
        <div>
          <Card className="ref-range-analysis-panel">
            <Card.Header className="ref-range-analysis-heading">
              {title}
              {!forPdf && (
                <>
                  &nbsp;
                  <OverlayTrigger overlay={refRangesInfoTooltip}>
                    <FontAwesomeIcon icon="external-link-alt" onClick={() => { this.openWindow(); }} />
                  </OverlayTrigger>
                </>
              )}
            </Card.Header>
            <Card.Body>
              <ReferenceRangeAnalysis
                title={title}
                section={section}
                bloodwork={bloodwork}
                previousBloodwork={previousBloodwork}
                panelMarkers={panelMarkers}
                infoLink={infoLink}
                forPdf={forPdf}
              />
            </Card.Body>
          </Card>
        </div> 
    );
  }
}
